import React from 'react';
import './styles.scss';

import unicefLogo from '../../../Assets/tpmShare/UNICEF_Logo.png';
import whoLogo from '../../../Assets/tpmShare/World_Health_Organization_Logo.png';
import worldBankLogo from '../../../Assets/tpmShare/World_Bank-Logo.wine.png';
import africanBankLogo from '../../../Assets/tpmShare/Mask_group.png';
import mapImage from '../../../Assets/tpmShare/map.png';

const TPMBanner = ({ heading }) => {
  return (
    <div className="tpm-banner">
      <div className="tpm-left">
        <h2 className="tpm-heading">{heading}</h2>
        <div className="tpm-logos">
          <img src={unicefLogo} alt="UNICEF" className="unicef-logo" />
          <img src={whoLogo} alt="WHO" className="who-logo" />
          <img src={worldBankLogo} alt="World Bank" className="worldbank-logo" />
          <img src={africanBankLogo} alt="African Development Bank" className="africanbank-logo" />
        </div>
      </div>
      <img src={mapImage} alt="Map" className="tpm-map" />
    </div>
  );
};

export default TPMBanner;